import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';

const getRegions = async () => {
  const response = await axios.get(HOST + '/api/dealer-portal/regions/by-country');
  return response.data;
};

export const usePrefetchRegions = () => {
  const queryClient = useQueryClient();
  queryClient.prefetchQuery({
    queryKey: ['regions'],
    queryFn: getRegions,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export const useRegions = () => {
  const query = useQuery({
    queryKey: ['regions'],
    queryFn: getRegions,
    staleTime: Infinity,
    gcTime: Infinity,
  });
  return query;
};
